// Saudi Arabia Regions and Cities
const regions = [
  {
    id: 'central',
    name: 'Central Region',
    cities: ['Riyadh', 'Al Kharj', 'Buraydah', 'Unaizah', 'Al Majma\'ah', 'Al Quwayiyah', 'Al Zulfi', 'Shaqra', 'Ad Dawadimi', 'Al Ghat', 'Huraymila']
  },
  {
    id: 'eastern',
    name: 'Eastern Region',
    cities: ['Dammam', 'Dhahran', 'Al Khobar', 'Qatif', 'Al Ahsa', 'Hofuf', 'Jubail', 'Ras Tanura', 'Abqaiq', 'Khafji', 'Safwa']
  },
  {
    id: 'western',
    name: 'Western Region',
    cities: ['Jeddah', 'Makkah', 'Madinah', 'Taif', 'Yanbu', 'Rabigh', 'Al Lith', 'Qunfudhah', 'Badr', 'Thuwal', 'Khulais']
  },
  {
    id: 'southern',
    name: 'Southern Region',
    cities: ['Abha', 'Khamis Mushait', 'Najran', 'Jizan', 'Al Baha', 'Sabya', 'Mahayil', 'Bariq', 'Ad Darb', 'Tanomah', 'Bisha']
  },
  {
    id: 'northern',
    name: 'Northern Region',
    cities: ['Tabuk', 'Arar', 'Sakaka', 'Hail', 'Al Jawf', 'Rafha', 'Turaif', 'Al Qurayyat', 'Dumat Al Jandal', 'Tayma', 'Al Ula']
  }
];

// Store Location Types
const locationTypes = [
  'Mall', 'Downtown', 'University', 'Hospital', 'Airport', 
  'Highway', 'Residential', 'Business District', 'Corniche', 
  'Tourist Area', 'Industrial Area'
];

// Manager Names Generator
const generateManagerName = () => {
  const firstNames = [
    'Ahmed', 'Mohammed', 'Ali', 'Omar', 'Khalid', 'Ibrahim', 'Abdullah', 'Saad',
    'Fahad', 'Yusuf', 'Nasser', 'Faisal', 'Saleh', 'Bandar', 'Turki', 'Majid',
    'Sarah', 'Fatima', 'Aisha', 'Norah', 'Hessa', 'Latifa', 'Maha', 'Reem',
    'Lama', 'Abeer', 'Haifa', 'Mona', 'Layla', 'Amira', 'Zainab', 'Nouf'
  ];
  const lastNames = [
    'Al-Saud', 'Al-Qahtani', 'Al-Otaibi', 'Al-Ghamdi', 'Al-Zahrani', 'Al-Shehri',
    'Al-Dossari', 'Al-Harbi', 'Al-Mutairi', 'Al-Asmari', 'Al-Shamrani', 'Al-Malki',
    'Al-Ruwaili', 'Al-Johani', 'Al-Faraj', 'Al-Najjar', 'Al-Qurashi', 'Al-Subaie',
    'Al-Thaqafi', 'Al-Rashidi', 'Al-Awaji', 'Al-Farsi', 'Al-Habib', 'Al-Yami'
  ];
  
  return `${firstNames[Math.floor(Math.random() * firstNames.length)]} ${lastNames[Math.floor(Math.random() * lastNames.length)]}`;
};

// Random number generator utilities
const randomBetween = (min, max, decimals = 0) => {
  const rand = Math.random() * (max - min) + min;
  const power = Math.pow(10, decimals);
  return Math.floor(rand * power) / power;
};

// Generate store data
const generateStores = (count = 104) => {
  const stores = [];
  let storeId = 1;
  
  // Distribute stores across regions, with more in central and western
  const regionDistribution = {
    'central': 0.32, // About 32% of stores
    'western': 0.28,  // About 28% of stores
    'eastern': 0.22,  // About 22% of stores
    'southern': 0.10, // About 10% of stores
    'northern': 0.08  // About 8% of stores
  };
  
  for (const regionId in regionDistribution) {
    const regionStoreCount = Math.floor(count * regionDistribution[regionId]);
    const region = regions.find(r => r.id === regionId);
    
    for (let i = 0; i < regionStoreCount; i++) {
      const city = region.cities[Math.floor(Math.random() * region.cities.length)];
      const locationType = locationTypes[Math.floor(Math.random() * locationTypes.length)];
      
      // Generate base scores with some randomness
      // Better scores for central and western regions on average
      let baseScore = 0;
      switch (regionId) {
        case 'central':
          baseScore = randomBetween(75, 95);
          break;
        case 'western':
          baseScore = randomBetween(72, 92);
          break;
        case 'eastern':
          baseScore = randomBetween(70, 90);
          break;
        case 'southern':
          baseScore = randomBetween(65, 88);
          break;
        case 'northern':
          baseScore = randomBetween(68, 85);
          break;
        default:
          baseScore = randomBetween(70, 90);
      }
      
      // Scores by category
      const salesScore = randomBetween(Math.min(baseScore * 0.3, 28), Math.min(30, baseScore * 0.32), 1);
      const reviewsScore = randomBetween(Math.min(baseScore * 0.2, 18), Math.min(20, baseScore * 0.22), 1);
      const maintenanceScore = randomBetween(Math.min(baseScore * 0.09, 8.5), Math.min(10, baseScore * 0.11), 1);
      const auditScore = randomBetween(Math.min(baseScore * 0.09, 8.5), Math.min(10, baseScore * 0.11), 1);
      const speedScore = randomBetween(Math.min(baseScore * 0.14, 13), Math.min(15, baseScore * 0.16), 1);
      const qualityScore = randomBetween(Math.min(baseScore * 0.14, 13), Math.min(15, baseScore * 0.16), 1);
      
      // Calculate total score
      const totalScore = Math.min(
        100, 
        +(salesScore + reviewsScore + maintenanceScore + auditScore + speedScore + qualityScore).toFixed(1)
      );
      
      // Store data
      stores.push({
        id: `S${String(storeId).padStart(3, '0')}`,
        name: `${city} ${locationType}`,
        region: region.name,
        city: city,
        managerName: generateManagerName(),
        totalScore: totalScore,
        salesScore: salesScore,
        reviewsScore: reviewsScore,
        maintenanceScore: maintenanceScore,
        auditScore: auditScore,
        speedScore: speedScore,
        qualityScore: qualityScore,
        // Additional metrics for detailed view
        salesMetrics: {
          growth: randomBetween(2, 15, 1),
          targetAchievement: randomBetween(85, 110, 1),
          avgTransaction: randomBetween(45, 75, 2),
          dailyTransactions: randomBetween(800, 1500),
          customerCount: randomBetween(25000, 45000)
        },
        reviewMetrics: {
          avgRating: randomBetween(3.5, 4.8, 1),
          totalReviews: randomBetween(150, 800),
          positiveSentiment: randomBetween(70, 95),
          responseRate: randomBetween(80, 100)
        },
        maintenanceMetrics: {
          activeIssues: randomBetween(1, 8),
          criticalIssues: randomBetween(0, 2),
          avgResolutionDays: randomBetween(1, 6, 1),
          preventiveMaintPct: randomBetween(60, 95)
        },
        auditMetrics: {
          lastAudit: randomBetween(1, 30) + ' days ago',
          cleanliness: randomBetween(75, 98),
          sopCompliance: randomBetween(70, 98),
          safety: randomBetween(80, 99)
        },
        serviceMetrics: {
          avgServiceTime: randomBetween(120, 240),
          driveThruTime: randomBetween(150, 300),
          counterTime: randomBetween(100, 200),
          orderAccuracy: randomBetween(92, 99, 1)
        },
        qualityMetrics: {
          productQuality: randomBetween(80, 98),
          presentation: randomBetween(75, 95),
          recipeAdherence: randomBetween(85, 99),
          temperature: randomBetween(90, 99)
        }
      });
      
      storeId++;
    }
  }
  
  return stores;
};

// Pre-generate stores
const storesData = generateStores();

// Generate Region Data with aggregated store performance
const generateRegionsData = () => {
  return regions.map(region => {
    const regionStores = storesData.filter(store => 
      store.region.toLowerCase().includes(region.id)
    );
    
    // Calculate averages
    const scoreSum = regionStores.reduce((sum, store) => sum + store.totalScore, 0);
    const salesScoreSum = regionStores.reduce((sum, store) => sum + store.salesScore, 0);
    const reviewsScoreSum = regionStores.reduce((sum, store) => sum + store.reviewsScore, 0);
    const maintenanceScoreSum = regionStores.reduce((sum, store) => sum + store.maintenanceScore, 0);
    const auditScoreSum = regionStores.reduce((sum, store) => sum + store.auditScore, 0);
    const speedScoreSum = regionStores.reduce((sum, store) => sum + store.speedScore, 0);
    const qualityScoreSum = regionStores.reduce((sum, store) => sum + store.qualityScore, 0);
    
    const avgScore = +(scoreSum / regionStores.length).toFixed(1);
    
    // Find top store
    const topStore = regionStores.reduce((max, store) => 
      max.totalScore > store.totalScore ? max : store, regionStores[0]
    );
    
    return {
      id: region.id,
      name: region.name,
      storeCount: regionStores.length,
      score: avgScore,
      salesScore: +(salesScoreSum / regionStores.length).toFixed(1),
      reviewsScore: +(reviewsScoreSum / regionStores.length).toFixed(1),
      maintenanceScore: +(maintenanceScoreSum / regionStores.length).toFixed(1),
      auditScore: +(auditScoreSum / regionStores.length).toFixed(1),
      speedScore: +(speedScoreSum / regionStores.length).toFixed(1),
      qualityScore: +(qualityScoreSum / regionStores.length).toFixed(1),
      change: randomBetween(-3, 8, 1),
      topStore: topStore.name
    };
  });
};

// Generate overview data (network-wide metrics)
const generateOverviewData = (period, regionFilter) => {
  // Filter stores by region if needed
  const filteredStores = regionFilter === 'all' 
    ? storesData 
    : storesData.filter(store => store.region.toLowerCase().includes(regionFilter));
  
  // Calculate averages
  const avgTotalScore = +(filteredStores.reduce((sum, store) => sum + store.totalScore, 0) / filteredStores.length).toFixed(1);
  const avgSalesScore = +(filteredStores.reduce((sum, store) => sum + store.salesScore, 0) / filteredStores.length).toFixed(1);
  const avgReviewsScore = +(filteredStores.reduce((sum, store) => sum + store.reviewsScore, 0) / filteredStores.length).toFixed(1);
  const avgMaintenanceScore = +(filteredStores.reduce((sum, store) => sum + store.maintenanceScore, 0) / filteredStores.length).toFixed(1);
  const avgAuditScore = +(filteredStores.reduce((sum, store) => sum + store.auditScore, 0) / filteredStores.length).toFixed(1);
  const avgSpeedScore = +(filteredStores.reduce((sum, store) => sum + store.speedScore, 0) / filteredStores.length).toFixed(1);
  const avgQualityScore = +(filteredStores.reduce((sum, store) => sum + store.qualityScore, 0) / filteredStores.length).toFixed(1);
  
  // Previous period is slightly lower to show improvement
  const previousTotalScore = +(avgTotalScore * randomBetween(0.95, 0.98, 2)).toFixed(1);
  
  // Generate aggregated metrics
  return {
    totalScore: avgTotalScore,
    previousTotalScore: previousTotalScore,
    salesScore: avgSalesScore,
    reviewsScore: avgReviewsScore,
    maintenanceScore: avgMaintenanceScore,
    auditScore: avgAuditScore,
    speedScore: avgSpeedScore,
    qualityScore: avgQualityScore,
    // Sales metrics
    salesMetrics: {
      growth: randomBetween(4, 12, 1),
      targetAchievement: randomBetween(90, 105, 1),
      avgTransaction: randomBetween(55, 65, 2),
      customerCount: randomBetween(3000000, 5000000),
      avgDailySales: randomBetween(28000, 35000),
      prevAvgDailySales: randomBetween(25000, 28000),
      dailyTransactions: randomBetween(1100, 1300),
      prevDailyTransactions: randomBetween(900, 1100),
      avgTransaction: randomBetween(50, 65, 2),
      prevAvgTransaction: randomBetween(45, 55, 2),
      customerGrowth: randomBetween(3, 8, 1),
      prevCustomerGrowth: randomBetween(1, 5, 1)
    },
    // Maintenance metrics
    maintenanceMetrics: {
      activeIssues: randomBetween(3, 5),
      prevActiveIssues: randomBetween(4, 7),
      criticalIssues: randomBetween(0, 2),
      avgResolutionDays: randomBetween(2, 4, 1),
      preventiveMaintPct: randomBetween(70, 85)
    },
    // Review metrics
    reviewMetrics: {
      avgRating: randomBetween(4.1, 4.5, 1),
      prevAvgRating: randomBetween(3.9, 4.2, 1),
      totalReviews: randomBetween(25000, 40000),
      positiveSentiment: randomBetween(80, 90),
      responseRate: randomBetween(85, 95)
    },
    // Service metrics
    serviceMetrics: {
      avgServiceTime: randomBetween(160, 180),
      prevAvgServiceTime: randomBetween(180, 200),
      driveThruTime: randomBetween(190, 220),
      counterTime: randomBetween(130, 160),
      orderAccuracy: randomBetween(94, 98, 1),
      prevOrderAccuracy: randomBetween(92, 96, 1)
    },
    // Audit metrics
    auditMetrics: {
      cleanliness: randomBetween(85, 92),
      sopCompliance: randomBetween(82, 90),
      safety: randomBetween(88, 95)
    },
    // Quality metrics
    qualityMetrics: {
      productQuality: randomBetween(85, 92),
      presentation: randomBetween(82, 90),
      recipeAdherence: randomBetween(88, 95),
      temperature: randomBetween(90, 98)
    }
  };
};

// Generate historical data for trends
const generateHistoricalData = (period, comparison) => {
  // TODO: Implement time-series data generation for charts
  // This would be more complex and depend on the charting library used
  
  return {
    period,
    comparison,
    trends: {
      totalScore: Array.from({ length: 12 }, () => randomBetween(70, 85, 1)),
      salesScore: Array.from({ length: 12 }, () => randomBetween(22, 27, 1)),
      reviewsScore: Array.from({ length: 12 }, () => randomBetween(15, 18, 1)),
      maintenanceScore: Array.from({ length: 12 }, () => randomBetween(7, 9, 1)),
      auditScore: Array.from({ length: 12 }, () => randomBetween(7, 9, 1)),
      speedScore: Array.from({ length: 12 }, () => randomBetween(10, 13, 1)),
      qualityScore: Array.from({ length: 12 }, () => randomBetween(10, 13, 1))
    }
  };
};

// Generate manager data
const generateManagersData = () => {
  // Regional Managers (1 per region)
  const regionalManagers = regions.map(region => {
    const regionStores = storesData.filter(store => 
      store.region.toLowerCase().includes(region.id)
    );
    
    // Calculate region performance
    const avgScore = +(regionStores.reduce((sum, store) => sum + store.totalScore, 0) / regionStores.length).toFixed(1);
    const lastYearScore = +(avgScore * randomBetween(0.92, 0.97, 1)).toFixed(1);
    const improvement = +(avgScore - lastYearScore).toFixed(1);
    
    return {
      id: `RM-${region.id.substring(0, 3).toUpperCase()}`,
      name: generateManagerName(),
      title: 'Regional Manager',
      region: region.name,
      storeCount: regionStores.length,
      avgScore: avgScore,
      lastYearScore: lastYearScore,
      improvement: improvement,
      salesPerformance: randomBetween(85, 110, 1),
      employeeSatisfaction: randomBetween(75, 95, 1),
      tenure: randomBetween(2, 15, 1)
    };
  });
  
  // District Managers (2-4 per region)
  const districtManagers = [];
  regions.forEach(region => {
    const districtCount = region.id === 'central' || region.id === 'western' ? 4 : 
                         region.id === 'eastern' ? 3 : 2;
    
    for (let i = 1; i <= districtCount; i++) {
      const regionStores = storesData.filter(store => 
        store.region.toLowerCase().includes(region.id)
      );
      
      // For each district, take a subset of stores
      const districtStores = regionStores.filter((_, index) => 
        index % districtCount === (i - 1)
      );
      
      const avgScore = +(districtStores.reduce((sum, store) => sum + store.totalScore, 0) / districtStores.length).toFixed(1);
      const lastYearScore = +(avgScore * randomBetween(0.90, 0.98, 1)).toFixed(1);
      const improvement = +(avgScore - lastYearScore).toFixed(1);
      
      districtManagers.push({
        id: `DM-${region.id.substring(0, 3).toUpperCase()}-${i}`,
        name: generateManagerName(),
        title: 'District Manager',
        district: `${region.name} District ${i}`,
        region: region.name,
        storeCount: districtStores.length,
        avgScore: avgScore,
        lastYearScore: lastYearScore,
        improvement: improvement,
        salesPerformance: randomBetween(82, 108, 1),
        employeeSatisfaction: randomBetween(72, 93, 1),
        tenure: randomBetween(1, 12, 1)
      });
    }
  });
  
  // Store Managers (1 per store)
  const storeManagers = storesData.map(store => {
    const lastYearScore = +(store.totalScore * randomBetween(0.88, 0.98, 1)).toFixed(1);
    const improvement = +(store.totalScore - lastYearScore).toFixed(1);
    
    return {
      id: `SM-${store.id}`,
      name: generateManagerName(), // should actually match the store's manager name
      title: 'Store Manager',
      storeName: store.name,
      region: store.region,
      store: store,
      avgScore: store.totalScore,
      lastYearScore: lastYearScore,
      improvement: improvement,
      salesPerformance: randomBetween(80, 105, 1),
      employeeSatisfaction: randomBetween(70, 90, 1),
      tenure: randomBetween(0.5, 10, 0.5)
    };
  });
  
  return {
    regionalManagers,
    districtManagers,
    storeManagers
  };
};

// Pre-generate manager data
const managersData = generateManagersData();

// Generate Sales Comparison Data
const generateSalesComparisonData = (period, comparison, region = 'all') => {
  // Base metrics
  const baseMetrics = {
    totalSales: randomBetween(8000000, 12000000),
    avgDailySales: randomBetween(250000, 350000),
    transactions: randomBetween(350000, 450000),
    avgTransaction: randomBetween(50, 65, 2),
    customersServed: randomBetween(300000, 400000)
  };
  
  // Apply period factor
  let periodFactor = 1;
  switch(period) {
    case 'week':
      periodFactor = 0.25;
      break;
    case 'month':
      periodFactor = 1;
      break;
    case 'quarter':
      periodFactor = 3;
      break;
    case 'year':
      periodFactor = 12;
      break;
    default:
      periodFactor = 1;
  }
  
  // Apply region factor
  let regionFactor = 1;
  if (region !== 'all') {
    const regionDistribution = {
      'central': 0.32,
      'western': 0.28,
      'eastern': 0.22,
      'southern': 0.10,
      'northern': 0.08
    };
    regionFactor = regionDistribution[region] || 0.2;
  }
  
  // Current period data
  const currentPeriod = {
    totalSales: Math.round(baseMetrics.totalSales * periodFactor * regionFactor),
    avgDailySales: Math.round(baseMetrics.avgDailySales * regionFactor),
    transactions: Math.round(baseMetrics.transactions * periodFactor * regionFactor),
    avgTransaction: baseMetrics.avgTransaction,
    customersServed: Math.round(baseMetrics.customersServed * periodFactor * regionFactor)
  };
  
  // Comparison period data (previous period, YoY, etc.)
  let comparisonPeriod;
  
  if (comparison === 'previous') {
    // Previous period (slightly lower performance)
    comparisonPeriod = {
      totalSales: Math.round(currentPeriod.totalSales * randomBetween(0.85, 0.95, 2)),
      avgDailySales: Math.round(currentPeriod.avgDailySales * randomBetween(0.85, 0.95, 2)),
      transactions: Math.round(currentPeriod.transactions * randomBetween(0.88, 0.97, 2)),
      avgTransaction: +(currentPeriod.avgTransaction * randomBetween(0.90, 0.98, 2)).toFixed(2),
      customersServed: Math.round(currentPeriod.customersServed * randomBetween(0.88, 0.97, 2))
    };
  } else if (comparison === 'yoy') {
    // Year over year (more significant difference)
    comparisonPeriod = {
      totalSales: Math.round(currentPeriod.totalSales * randomBetween(0.80, 0.90, 2)),
      avgDailySales: Math.round(currentPeriod.avgDailySales * randomBetween(0.80, 0.90, 2)),
      transactions: Math.round(currentPeriod.transactions * randomBetween(0.82, 0.92, 2)),
      avgTransaction: +(currentPeriod.avgTransaction * randomBetween(0.85, 0.95, 2)).toFixed(2),
      customersServed: Math.round(currentPeriod.customersServed * randomBetween(0.82, 0.92, 2))
    };
  } else if (comparison === 'budget') {
    // Budget/target (slightly below budget)
    comparisonPeriod = {
      totalSales: Math.round(currentPeriod.totalSales * randomBetween(1.02, 1.08, 2)),
      avgDailySales: Math.round(currentPeriod.avgDailySales * randomBetween(1.02, 1.08, 2)),
      transactions: Math.round(currentPeriod.transactions * randomBetween(1.01, 1.05, 2)),
      avgTransaction: +(currentPeriod.avgTransaction * randomBetween(1.01, 1.05, 2)).toFixed(2),
      customersServed: Math.round(currentPeriod.customersServed * randomBetween(1.01, 1.05, 2))
    };
  } else {
    // Default to previous period
    comparisonPeriod = {
      totalSales: Math.round(currentPeriod.totalSales * randomBetween(0.85, 0.95, 2)),
      avgDailySales: Math.round(currentPeriod.avgDailySales * randomBetween(0.85, 0.95, 2)),
      transactions: Math.round(currentPeriod.transactions * randomBetween(0.88, 0.97, 2)),
      avgTransaction: +(currentPeriod.avgTransaction * randomBetween(0.90, 0.98, 2)).toFixed(2),
      customersServed: Math.round(currentPeriod.customersServed * randomBetween(0.88, 0.97, 2))
    };
  }
  
  // Calculate daily sales for chart data
  const days = period === 'week' ? 7 : period === 'month' ? 30 : period === 'quarter' ? 90 : 365;
  const currentDailySales = Array.from({ length: days }, () => Math.round(currentPeriod.avgDailySales * randomBetween(0.7, 1.3, 2)));
  const comparisonDailySales = Array.from({ length: days }, () => Math.round(comparisonPeriod.avgDailySales * randomBetween(0.7, 1.3, 2)));
  
  return {
    currentPeriod,
    comparisonPeriod,
    dailySales: {
      current: currentDailySales,
      comparison: comparisonDailySales
    },
    // Calculate percent changes
    changes: {
      totalSales: +((currentPeriod.totalSales / comparisonPeriod.totalSales - 1) * 100).toFixed(1),
      avgDailySales: +((currentPeriod.avgDailySales / comparisonPeriod.avgDailySales - 1) * 100).toFixed(1),
      transactions: +((currentPeriod.transactions / comparisonPeriod.transactions - 1) * 100).toFixed(1),
      avgTransaction: +((currentPeriod.avgTransaction / comparisonPeriod.avgTransaction - 1) * 100).toFixed(1),
      customersServed: +((currentPeriod.customersServed / comparisonPeriod.customersServed - 1) * 100).toFixed(1)
    }
  };
};

// --- Data API ---

// Get all stores data
export const getStoresData = async (period = 'month', regionFilter = 'all') => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // If filtering by region
  if (regionFilter !== 'all') {
    return storesData.filter(store => 
      store.region.toLowerCase().includes(regionFilter)
    );
  }
  
  return storesData;
};

// Get regions data
export const getRegionsData = async () => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 600));
  
  return generateRegionsData();
};

// Get overview data
export const getOverviewData = async (period = 'month', regionFilter = 'all') => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 800));
  
  return generateOverviewData(period, regionFilter);
};

// Get historical data for trends
export const getHistoricalData = async (period = 'month', comparison = 'previous') => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 700));
  
  return generateHistoricalData(period, comparison);
};

// Get managers data
export const getManagersData = async (type = 'all') => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 600));
  
  if (type === 'regional') {
    return managersData.regionalManagers;
  }
  if (type === 'district') {
    return managersData.districtManagers;
  }
  if (type === 'store') {
    return managersData.storeManagers;
  }
  
  return managersData;
};

// Get sales comparison data
export const getSalesComparisonData = async (period = 'month', comparison = 'previous', region = 'all') => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 700));
  
  return generateSalesComparisonData(period, comparison, region);
}; 